import type {ExtractPropsWithoutRef} from '@/types';

import {CampaignBanner as CampaignBannerShared} from '@travel-frontend/ui-components';
import {useEffect} from 'react';

import {useTracking} from '@/modules/common/hooks/useTracking';

type Props = ExtractPropsWithoutRef<typeof CampaignBannerShared> & {
  position: number;
};

export const CampaignBanner: React.FunctionComponent<Props> = ({
  onClick,
  position,
  ...restProps
}) => {
  const {dispatchGenericTrackingEvent} = useTracking();
  const handleClick = () => {
    dispatchGenericTrackingEvent({
      event: 'promotion_banner',
      event_action: 'cashback_click',
      ad_position: `${position}`,
      non_interaction: false,
    });

    onClick();
  };

  useEffect(() => {
    dispatchGenericTrackingEvent({
      event: 'promotion_banner',
      event_action: 'cashback_loaded',
      ad_position: `${position}`,
      non_interaction: true,
    });
  }, [dispatchGenericTrackingEvent, position]);

  return <CampaignBannerShared onClick={handleClick} {...restProps} />;
};
